const modules = {
	versionDisplay: "versionDisplay",
	accordionComponent: "accordion",
	breadcrumbComponent: "breadcrumb",
	chartComponent: "chart",
	chartExpansionComponent: "chartExpansion",
	chartStatisticsComponent: "chartStatistics",
	checkboxComponent: "checkbox",
	contentLinksComponent: "contentLinks",
	datepickerComponent: "datepicker",
	disclaimerOverlayComponent: 'disclaimerOverlay',
	factsheetComponent: "factsheet",
	fileUploadComponent: "file-upload",
	formComponent: "form",
	galleryComponent: "gallery",
	handlePagination: "handlePagination",
	headerComponent: "header",
	hamburgerComponent: "hamburger",
	headerSliderComponent: "header-slider",
	inputFieldComponent: "input",
	mapComponent: "map",
	newsCategoriesComponent: "news-categories",
	newsListComponent: "news-list",
	lazyloadComponent: "lazyloadComponent",
	lightboxComponent: "lightboxComponent",
	multiselectComponent: "multiselect",
	overlayComponent: "overlay",
	radiofieldComponent: "radiofield",
	selectComponent: "select",
	sliderContainerComponent: "sliderContainer",
	tabsComponent: "tabs",
	searchComponent: "search",
	tableComponent: "table",
	tableAccordionComponent: "table-accordion",
	textInputComponent: "text-input",
	tableFilterComponent: "table-filter",
	newsSearchComponent: "news-search"
}

const loadedModules = {}

class DynamicModuleLoader {
	/**
	 * get the list of dynamic Modules
	 * @returns object
	 */
	get modules() {
		return modules
	}

	/**
	 * use webpack dynamic imports
	 * @param componentName {string}
	 * @param callback {function}
	 * @private
	 */
	_import(componentName, callback) {
		if (typeof componentName === "string" && typeof callback === "function") {
			let modulePromise

			switch (componentName) {
				case modules.versionDisplay:
					modulePromise = import(/* webpackChunkName: "versionDisplay" */ "../components/VersionDisplay")
					break
				case modules.accordionComponent:
					modulePromise = import(/* webpackChunkName: "accordion" */ "../../components/accordion/accordion")
					break
				case modules.breadcrumbComponent:
					modulePromise = import(/* webpackChunkName: "breadcrumb" */ "../../components/breadcrumb/breadcrumb")
					break
				case modules.chartComponent:
					modulePromise = import(/* webpackChunkName: "chart" */ "../../components/chart/chart")
					break
				case modules.chartExpansionComponent:
					modulePromise = import(/* webpackChunkName: "chartExpansion" */ "../../components/chart-expansion/chart-expansion")
					break
				case modules.chartStatisticsComponent:
					modulePromise = import(/* webpackChunkName: "chartStatistics" */ "../../components/chart-statistics/chart-statistics")
					break
				case modules.checkboxComponent:
					modulePromise = import(/* webpackChunkName: "checkbox" */ "../../components/checkbox/checkbox")
					break
				case modules.contentLinksComponent:
					modulePromise = import(/* webpackChunkName: "contentLinks" */ "../../components/content-links/content-links")
					break
				case modules.datepickerComponent:
					modulePromise = import(/* webpackChunkName: "datepicker" */ "../../components/datepicker/datepicker")
					break
				case modules.disclaimerOverlayComponent:
					modulePromise = import(/* webpackChunkName: "disclaimer-overlay" */ "../../components/disclaimer-overlay/disclaimer-overlay")
					break
				case modules.factsheetComponent:
					modulePromise = import(/* webpackChunkName: "factsheet" */ "../../components/factsheet/factsheet")
					break
				case modules.fileUploadComponent:
					modulePromise = import(/* webpackChunkName: "fileUpload" */ "../../components/file-upload/file-upload")
					break
				case modules.formComponent:
					modulePromise = import(/* webpackChunkName: "form" */ "../../components/form/form")
					break
				case modules.galleryComponent:
					modulePromise = import(/* webpackChunkName: "gallery" */ "../../components/gallery/gallery")
					break
				case modules.handlePagination:
					modulePromise = import(/* webpackChunkName: "handle-pagination" */ "../utils/HandlePagination")
					break
				case modules.headerComponent:
					modulePromise = import(/* webpackChunkName: "header" */ "../../components/header/header")
					break
				case modules.hamburgerComponent:
					modulePromise = import(/* webpackChunkName: "hamburger" */ "../../components/hamburger/hamburger")
					break
				case modules.headerSliderComponent:
					modulePromise = import(/* webpackChunkName: "header-slider" */ "../../components/header-slider/header-slider")
					break
				case modules.inputFieldComponent:
					modulePromise = import(/* webpackChunkName: "input-field" */ "../../components/inputfield/inputfield")
					break
				case modules.mapComponent:
					modulePromise = import(/* webpackChunkName: "map" */ "../../components/map/map")
					break
				case modules.newsCategoriesComponent:
					modulePromise = import(/* webpackChunkName: "news-categories" */ "../../components/news-categories/news-categories")
					break
				case modules.newsListComponent:
					modulePromise = import(/* webpackChunkName: "news-list" */ "../../components/news-list/news-list")
					break
				case modules.lazyloadComponent:
					modulePromise = import(/* webpackChunkName: "lazyLoad" */ "../components/LazyLoad")
					break
				case modules.lightboxComponent:
					modulePromise = import(/* webpackChunkName: "lightbox" */ "../components/Lightbox")
					break
				case modules.multiselectComponent:
					modulePromise = import(/* webpackChunkName: "multiselect" */ "../../components/multiselect/multiselect")
					break
				case modules.overlayComponent:
					modulePromise = import(/* webpackChunkName: "overlay" */ "../../components/overlay/overlay")
					break
				case modules.radiofieldComponent:
					modulePromise = import(/* webpackChunkName: "radiofield" */ "../../components/radiofield/radiofield")
					break
				case modules.selectComponent:
					modulePromise = import(/* webpackChunkName: "select" */ "../../components/select/select")
					break
				case modules.sliderContainerComponent:
					modulePromise = import(/* webpackChunkName: "slider-container" */ "../../components/slider-container/slider-container")
					break
				case modules.tabsComponent:
					modulePromise = import(/* webpackChunkName: "tabs" */ "../../components/tabs/tabs")
					break
				case modules.searchComponent:
					modulePromise = import(/* webpackChunkName: "search" */ "../../components/search/search")
					break
				case modules.tableComponent:
					modulePromise = import(/* webpackChunkName: "table" */ "../../components/table/table")
					break
				case modules.tableAccordionComponent:
					modulePromise = import(/* webpackChunkName: "table-accordion" */ "../../components/table-accordion/table-accordion")
					break
				case modules.textInputComponent:
					modulePromise = import(/* webpackChunkName: "text-input" */ "../../components/text-input/text-input")
					break
				case modules.tableFilterComponent:
					modulePromise = import(/* webpackChunkName: "table-filter" */ "../../components/table-filter/table-filter")
					break
				case modules.newsSearchComponent:
					modulePromise = import(/* webpackChunkName: "news-search" */ "../../components/news-search/news-search")
					break
				default:
					// eslint-disable-next-line no-console
					console.warn("Module not found")
					break
			}

			modulePromise.then((component) => {
				callback(component.default)
			})
		}
	}

	/**
	 * Dynamically Module Loader
	 * @param condition {boolean}
	 * @param componentName {string}
	 * @param onLoadComponent {function}
	 */
	load(condition, componentName, onLoadComponent = undefined) {
		if (condition) {
			if (!loadedModules[componentName]) {
				this._import(componentName, (Component) => {
					if (typeof onLoadComponent === "function") {
						onLoadComponent(Component)
					} else {
						new Component()
					}
					loadedModules[componentName] = Component
				})
			} else {
				if (typeof onLoadComponent === "function") {
					onLoadComponent(loadedModules[componentName])
				}
			}
		}
	}
}

export default new DynamicModuleLoader()
